import { useState } from "react";
import { Grid } from "@mui/material";
import { ProductSearchContext } from "./useInfiniteSearchProducts";
import { SkeletonCard } from "~src/components/SkeletonCard";
import BottomScrollListener from "~src/components/BottomScrollListener";
import useCollapseDrawer from "~src/hooks/useCollapseDrawer";
import ProductTile from "../search/ProductTile";
import ContentBox from "~src/components/ContentBox";
import EmptyContent from "~src/components/EmptyContent";

export const SearchProductList = ({
  productSearchContext,
}: {
  productSearchContext: ProductSearchContext;
}) => {
  const { data, loadMore, loading } = productSearchContext;
  const { isCollapse } = useCollapseDrawer();

  const [loadedImages, setLoadedImages] = useState<string[]>([]);

  const handleImageLoad = (imageUrl: string) => {
    setLoadedImages((prev) => [...prev, imageUrl]);
  };

  if ((!data || data.length <= 0) && loading === false) {
    return (
      <ContentBox>
        <EmptyContent
          title="No products"
          description="Try using some another search term."
        />
      </ContentBox>
    );
  }

  return (
    <Grid container spacing={2}>
      {data.map((product) => {
        if (!product || !product.product_image_url) {
          return null;
        }

        if (!loadedImages.includes(product.product_image_url)) {
          return (
            <img
              key={product.product_variant_id}
              src={product.product_image_url}
              alt=""
              style={{ display: "none" }}
              onLoad={() => handleImageLoad(product.product_image_url)}
            />
          );
        }

        return (
          <Grid key={product.product_variant_id}
            size={{ xs: 12, md: isCollapse ? 3 : 4 , sm: 6 }}
            
            
          >
            <ProductTile
              product={product}
              brandName={product?.product_name || ""}
            />
          </Grid>
        );
      })}

      {loading &&
        Array(4)
          .fill(null)
          .map((_, index) => (
            <Grid key={index} size={{ xs: 12, md: isCollapse ? 3 : 4 , sm: 6 }}  >
              <SkeletonCard key={index} />
            </Grid>
          ))}
      <BottomScrollListener
        offset={400}
        onBottom={() => {
          loadMore();
        }}
      />
    </Grid>
  );
};
